import new_germany from '../images/newProductPage/languages/DE.png';
import new_spanish from '../images/newProductPage/languages/ES.png';
import new_french from '../images/newProductPage/languages/FR.png';
import new_italy from '../images/newProductPage/languages/IT.png';
import new_niderland from '../images/newProductPage/languages/ND.png';
import new_polish from '../images/newProductPage/languages/PL.png';
import new_portugal from '../images/newProductPage/languages/PR.png';
import new_russia from '../images/newProductPage/languages/RU.png';
import new_england from '../images/newProductPage/languages/UK.png';

import screen1 from '../images/newProductPage/estonian/1.png';
import screen2 from '../images/newProductPage/estonian/2.png';
import screen3 from '../images/newProductPage/estonian/3.png';
import screen4 from '../images/newProductPage/estonian/4.png';

import dlaczego1 from '../images/newProductPage/why/o-nas-1.png';
import dlaczego2 from '../images/newProductPage/why/o-nas-2.png';
import dlaczego3 from '../images/newProductPage/why/o-nas-3.png';

import zdjecie2 from '../images/newProductPage/mission/kolo3-mobile.png';
import zdjecie3 from '../images/newProductPage/mission/kolo2-mobile.png';
import zdjecie1 from '../images/newProductPage/mission/kolo1-mobile.png';

export const russian = {
  navbar: {
    data: [
      { title: 'Заказать курс', path: '/course' },
      { title: 'Зарегистрироваться', path: '/start' },
      { title: 'Sõnasiht', path: '/' },
      { title: 'О нас', path: '/about' },
      { title: 'Отзывы', path: '/reviews' },
    ],
  },
  mainPage: {
    product_page: {
      faq: {
        title: 'Часто задаваемые вопросы',
        subtitle: 'Есть вопросы? У нас есть ответы.',
        sections: [
          {
            title: 'О Sõnasiht',
            questions: [
              {
                question: 'Что такое Sõnasiht?',
                answer:
                  'Sõnasiht — это онлайн-платформа для изучения иностранных языков, которая позволяет быстро и эффективно освоить навыки говорения и понимания на практике.',
              },
              {
                question: 'Как работают языковые курсы Sõnasiht?',
                answer:
                  'После регистрации вы получаете доступ к интерактивным онлайн-урокам и материалам, которые можно проходить в удобное для вас время. Курсы адаптированы под ваш уровень и цели.',
              },
              {
                question: 'Действительно ли Sõnasiht помогает развить навык говорения?',
                answer:
                  'Да. Наши курсы сосредоточены на практическом общении — благодаря интерактивным упражнениям вы быстро преодолеете языковой барьер.',
              },
            ],
          },
          {
            title: 'Оплата и доставка',
            questions: [
              {
                question: 'Как я могу оплатить курс Sõnasiht?',
                answer:
                  'Вы можете оплатить онлайн или наличными курьеру при получении.',
              },
              {
                question: 'Защищены ли мои данные и платежи?',
                answer:
                  'Да. Все данные защищены в соответствии с GDPR, а платежи — как онлайн, так и при получении — безопасны и обрабатываются надёжными партнёрами.',
              },
              {
                question: 'Безопасна ли оплата при получении?',
                answer:
                  'Да. Курьер доставит посылку, а оплата производится безопасно при получении товара.',
              },
              {
                question:
                  'Когда я получу доступ к курсу после оплаты заказа?',
                answer:
                  'Доступ активируется автоматически после введения кода на указанной странице.',
              },
              {
                question: 'Что произойдёт, если я не приму посылку?',
                answer:
                  'Если вы не примете посылку, доступ к курсу не будет активирован. Однако вы можете заказать курс повторно в любое время.',
              },
            ],
          },
          {
            title: 'Безопасность, доверие и поддержка',
            questions: [
              {
                question: 'Защищены ли мои персональные данные в Sõnasiht?',
                answer:
                  'Да. Мы используем шифрование данных и меры защиты, соответствующие европейским стандартам.',
              },
              {
                question:
                  'Является ли Sõnasiht законной и зарегистрированной компанией?',
                answer:
                  'Да. Sõnasiht — образовательный бренд, принадлежащий компании European Learning Agency. Компания действует на законных основаниях и зарегистрирована в Европейском союзе. Подробную информацию вы найдёте в условиях на нашем сайте.',
              },
              {
                question:
                  'Как я могу связаться со службой поддержки Sõnasiht?',
                answer:
                  'Вы можете написать на адрес klienditugi@sonasiht-edu.com или воспользоваться контактной формой на сайте.',
              },
              {
                question:
                  'Предлагаете ли вы гарантию удовлетворённости или возврат денег?',
                answer:
                  'Да. Если курс не оправдает ваших ожиданий, мы предоставим возможность отказа или возврата в соответствии с условиями — без каких-либо рисков.',
              },
            ],
          },
        ],
      },
      language: 'ru',
      hero: {
        languages: [
          'по-английски',
          'по-испански',
          'по-немецки',
          'по-нидерландски',
          'по-итальянски',
          'по-русски',
          'по-польски',
          'по-французски',
          'по-португальски',
        ],
        title: 'Говорите увереннее,',
        prefix: 'уверенно',
        subtitle:
          'Развивайте свои языковые навыки с нашим курсом, основанным на реальных примерах!',
        buttonText: 'Заказать сейчас!',
      },
      learning: {
        title: 'Как выглядит курс?',
        config: [
          {
            image: screen1,
            category: 'Учите язык самым простым способом',
            descriptions: [
              {
                bold: 'Десятки уроков',
                rest: 'с примерами из повседневного общения.',
              },
              {
                bold: 'Практические фразы',
                rest: 'составленные носителями языка.',
              },
              {
                bold: 'Упражнения,',
                rest: 'которые эффективно развивают навыки чтения, аудирования и говорения.',
              },
            ],
          },
          {
            image: screen2,
            category: 'Практические уроки',
            description:
              'Каждый уровневый курс состоит из десятков уроков, адаптированных под ваши потребности.',
          },
          {
            image: screen3,
            category: 'Задания',
            description:
              'Наши упражнения эффективно поддерживают повторение материала и улучшают память.',
          },
          {
            image: screen4,
            category: 'Слова, фразы и выражения',
            description:
              'Каждый урок содержит тщательно подобранные изображения, которые делают обучение интуитивным.',
          },
        ],
        photoData: [screen1, screen2, screen3, screen4],
      },
      languages: {
        languages: [
          { image: new_england, lang: 'Английский' },
          { image: new_french, lang: 'Французский' },
          { image: new_spanish, lang: 'Испанский' },
          { image: new_niderland, lang: 'Нидерландский' },
          { image: new_germany, lang: 'Немецкий' },
          { image: new_italy, lang: 'Итальянский' },
          { image: new_russia, lang: 'Русский' },
          { image: new_portugal, lang: 'Португальский' },
          { image: new_polish, lang: 'Польский' },
        ],
        title: 'Доступные языки:',
        description:
          'Подготовьтесь к следующей поездке или добавьте языковые навыки в своё резюме.',
      },
      expertSection: {
        title: 'Ваш языковой эксперт',
        firstSectionTitle: 'Поддержка всегда рядом',
        firstSectionDescription: 'Получите полную поддержку во время обучения!',
        secondSectionTitle: 'Задавайте вопросы и получайте ответы',
        secondSectionDescription:
          'Все вопросы вы можете задавать напрямую своему эксперту.',
        thirdSectionTitle: 'Индивидуальный подход на каждом шагу',
        thirdSectionDescription:
          'Использование советов языкового эксперта ускорит ваше обучение.',
      },
      courseValue: {
        title: 'Получите больше вместе с Sõnasiht',
        subtitle:
          'Не только изучение языка — вы получаете полный доступ к инструментам',
        buttonText: 'Заказать сейчас!',
        config: [
          {
            title: 'Обучение, адаптированное под ваш образ жизни',
            sections: [
              {
                text: 'С нашей платформой вы можете учиться где и когда угодно.',
              },
              {
                text: 'Короткие уроки идеально вписываются в ваш распорядок дня.',
              },
            ],
          },
          {
            title: 'Мотивация на каждом шагу',
            sections: [
              {
                text: 'Поддерживайте мотивацию с помощью нашей системы отслеживания прогресса.',
              },
              {
                text: 'Каждый учебный день приближает вас к свободному общению.',
              },
            ],
          },
          {
            title: 'Полная гибкость и персонализация',
            sections: [
              {
                text: 'Адаптируйте курс под свой уровень и темп обучения.',
              },
              {
                text: 'Сосредоточьтесь на том, что вас интересует больше всего.',
              },
            ],
          },
        ],
      },
    },
  },
  aboutUs: {
    hero: {
      title: 'Миссия',
      description: `Наша конечная цель в среде Sõnasiht — предоставить каждому доступ к персональному преподавателю с помощью технологий. Мы верим, что язык — это мост между культурами, и наша миссия — преодолевать коммуникационные барьеры и объединять людей через изучение языков.`,
    },
    why: {
      title: 'Почему мы?',
      config: [
        {
          title: 'Инновационные методики обучения',
          image: dlaczego1,
          description:
            'Наш сложный, но проверенный на практике алгоритм обучения адаптирует учебные материалы под ваш текущий уровень знаний и дополняет его через эффективное обучение.',
        },
        {
          title: 'Широкий выбор языков',
          image: dlaczego2,
          description:
            'Мы предлагаем курсы по самым распространённым языкам мира. Это позволяет вам выбрать язык, отвечающий вашим потребностям.',
        },
        {
          title: 'Образование в удовольствие',
          image: dlaczego3,
          description:
            'Наша платформа делает изучение языков весёлым и приятным опытом, который поддерживает вашу мотивацию.',
        },
      ],
    },
    mission: {
      config: [
        {
          title: 'Персонализация и доступность',
          description:
            'Наш мощный алгоритм машинного обучения постоянно работает над тем, чтобы предоставлять каждому учащемуся материалы нужного уровня. Sõnasiht позволяет учащимся самостоятельно открывать закономерности, не концентрируясь на языковых правилах — точно так же, как вы учили родной язык в детстве.',
          image: zdjecie1,
        },
        {
          title: 'Смелое сочетание технологий и науки',
          description:
            'Sõnasiht смело использует сочетание технологий и науки, чтобы активизировать ваш мозг. Бесконечное повторение списков слов и фраз скучно, и ваш мозг это знает. Наш метод, который помогает применять полученные знания по-разному в разные моменты времени, увлекателен и эффективен — ваш мозг это оценит!',
          image: zdjecie2,
        },
        {
          title: 'Сообщество и ценность',
          description:
            'Языки помогают людям оставаться активными. Изучение языков способствует взаимопониманию. Сообщество Sõnasiht объединяет людей со всего мира. Мы амбициозны и постоянно раздвигаем границы. Мы верим, что изучение языков должно быть увлекательным, и любопытны в открытии новых культур через языки.',
          image: zdjecie3,
        },
      ],
    },
  },
  formSender: {
    formControll: {
      pageLink: 'https://nyelvfejlesztesi-kozpont.eu/',
      title: 'Вас интересует курс?',
      title1: 'Вам нужна дополнительная информация?',
      subtitle: 'Оставьте нам свой номер — мы вам перезвоним',
      subtitle1: 'Если у вас уже есть аккаунт, пожалуйста, заполните следующие поля:',
      button1: 'Имя и фамилия',
      button2: 'Номер телефона',
      button3: 'E-mail',
      buttonSub: 'Хочу звонок',
      checkOne:
        'Отправляя эту форму, я соглашаюсь с условиями и подтверждаю, что прочитал(а) условия и политику защиты данных.',
      checkOneTwo: 'и',
      checkTwo:
        'Я соглашаюсь на то, чтобы со мной связывались в маркетинговых целях.',
      textOne: 'Сообщаем вам, что',
      textTwo:
        'Администратором ваших персональных данных является EOU Sp. z o.o., регистрационный номер KRS 0001038089, REGON 525396900, NIP 5273057993, расположенная в Варшаве по адресу: Młynarska 42/115, 01-171, внесённая в реестр предпринимателей Окружного суда Варшавы. Ваши персональные данные обрабатываются в связи с запросом через контактную форму или для исполнения заключённого договора. Обращаясь к нам, вы добровольно даёте согласие на обработку ваших персональных данных в вышеуказанных целях. Вы имеете право на доступ к данным, их исправление, удаление или ограничение обработки, подачу возражений против обработки и переносимость данных. Вы также вправе в любое время отозвать своё согласие, однако его отзыв не влияет на законность обработки, осуществлённой до отзыва. Вы имеете право подать жалобу в надзорный орган. Предоставление данных является добровольным, однако может быть необходимо для ответа на запрос или исполнения договора. Персональные данные хранятся до тех пор, пока это необходимо для вышеуказанных целей, но не дольше срока исковой давности, установленного общим законодательством. Просим внимательно ознакомиться с политикой конфиденциальности.',
      buttonMore: 'Читать далее',
      buttonLess: 'Скрыть',
      subOne: 'условия оказания услуг',
      subTwo: 'и политику конфиденциальности.',
      buttonTXT: 'Спасибо',
      rulesLink: '/Regulations_ET_European_Learning_Agency_Sonasiht.pdf',
      privacyLink: '/Privacy_ET_European_Learning_Agency.pdf',
      product: 'se',
      market: 'ee',
      send_to_url: 'https://crm.eou-edu.eu/api/v1/cms/create_order',
      utm_source: 'Platform_Sonasiht',
      product_variant: 'et-en',
      server_link: 'https://cms.eou-edu.eu/integration/lead-from-landing',
      currency: 'eur',
      price: 89,
    },
  },
  reviews: {
    language: 'ru',
    title: 'Отзывы о Sõnasiht',
    subtitle:
      'Ваш отзыв важен — отзывы о Sõnasiht помогают нам развивать платформу в соответствии с потребностями пользователей.',
    contentPlaceholder: 'Начните писать',
    submitButton: 'Отправить',
    thankYouText:
      'Спасибо, что поделились своим опытом и помогаете нам создавать эффективный инструмент для изучения языков!',
    recommendedLabel: 'Рекомендуем',
    items: [
      {
        text: 'Метод обучения отличный, намного лучше того, что я встречал на других платформах.',
        isRecommended: true,
      },
      {
        text: 'Благодаря интерактивным упражнениям я быстро продвинулся. С уверенностью рекомендую всем, кто хочет реальных результатов.',
        isRecommended: true,
        isLarge: true,
      },
      {
        text: 'Очень интуитивная платформа. Я освоился с первых минут без какой-либо помощи.',
        isRecommended: true,
      },
      {
        text: 'Техническая поддержка быстрая. Ни секунды я не чувствовал себя одиноким в этом процессе.',
        isRecommended: true,
      },
      {
        text: 'Материалы чрезвычайно хорошо структурированы и дают ясное представление об учебном процессе. Каждый урок логично следует за предыдущим, делая прогресс очень естественным и интуитивным. Объяснения подробные, а практические примеры очень помогают закрепить знания, превращая учёбу в приятный и эффективный в долгосрочной перспективе опыт.',
        isRecommended: true,
        isTall: true,
      },
      {
        text: 'Гибкость — главное преимущество. Я могу учиться в любое время, в любом месте, на любом устройстве.',
        isRecommended: true,
      },
      {
        text: 'Дизайн приятен для глаз. Я могу учиться часами, не уставая.',
        isRecommended: true,
      },
      {
        text: 'Мне удалось улучшить словарный запас в рекордные сроки. Всё очень практично.',
        isRecommended: true,
      },
      {
        text: 'По-настоящему современный опыт обучения. Это помогло мне преодолеть страх говорить на иностранном языке.',
        isRecommended: true,
        isLarge: true,
      },
      {
        text: 'Качество звука курсов безупречное, что необходимо для правильного понимания.',
        isRecommended: true,
      },
      {
        text: 'Система геймификации мотивирует возвращаться каждый день и постоянно прогрессировать.',
        isRecommended: true,
      },
      {
        text: 'Удивительно, как видишь заметный прогресс от недели к неделе. Инвестиция того стоит!',
        isRecommended: true,
      },
      {
        text: 'Интерфейс чистый, без рекламы и элементов, которые отвлекают от учёбы.',
        isRecommended: true,
      },
      {
        text: 'Сообщество очень активное и дружелюбное. Всегда находишь ответы на вопросы.',
        isRecommended: true,
      },
    ],
  },
  footer: {
    title: 'Присоединяйтесь к нам:',
    privacy: 'Конфиденциальность',
    privacyLink: '/Privacy_ET_European_Learning_Agency.pdf',
    rules: 'Условия оказания услуг',
    rulesLink: '/Regulations_ET_European_Learning_Agency_Sonasiht.pdf',
  },
};
